// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const Visibility = {
  "PUBLIC": "public",
  "PRIVATE": "private"
};

const MediaContentType = {
  "ARTICLE_COVER": "ArticleCover",
  "ENTRY_POINT": "EntryPoint",
  "SITE": "Site",
  "MAP": "Map",
  "SURVEY_DATA": "SurveyData",
  "TRACK_DATA": "TrackData",
  "WILDLIFE": "Wildlife"
};

const ReportVisibility = {
  "UNSPECIFIED": "Unspecified",
  "TERRIBLE": "Terrible",
  "BAD": "Bad",
  "OK": "Ok",
  "GOOD": "Good",
  "EXCELLENT": "Excellent",
  "OUTSTANDING": "Outstanding"
};

const ReportSwell = {
  "UNSPECIFIED": "Unspecified",
  "CALM": "Calm",
  "SMOOTH": "Smooth",
  "SLIGHT": "Slight",
  "ROUGH": "Rough",
  "DANGEROUS": "Dangerous"
};

const ReportWind = {
  "UNSPECIFIED": "Unspecified",
  "LIGHT_BREEZE": "LightBreeze",
  "GENTLE_BREEZE": "GentleBreeze",
  "MODERATE_BREEZE": "ModerateBreeze",
  "FRESH_BREEZE": "FreshBreeze",
  "STRONG_BREEZE": "StrongBreeze",
  "DANGEROUS": "Dangerous"
};

const LocationType = {
  "UNKNOWN": "Unknown",
  "NOT_FOUND": "NotFound",
  "DEPRESSION": "Depression",
  "CAVE": "Cave",
  "SINKHOLE": "Sinkhole",
  "SOLUTION_TUBE": "SolutionTube",
  "DESTROYED": "Destroyed",
  "ROCKY_OUTCROP": "RockyOutcrop",
  "LANDMARK": "Landmark",
  "MINE": "Mine",
  "WRECK": "Wreck",
  "REEF": "Reef",
  "JETTY": "Jetty",
  "MUCK": "Muck",
  "SAND": "Sand",
  "OCEAN_WALL": "OceanWall",
  "CAMPSITE": "Campsite"
};

const EntryType = {
  "UNKNOWN": "Unknown",
  "BOAT": "Boat",
  "SHORE": "Shore"
};

const CaveRating = {
  "UNKNOWN": "Unknown",
  "NONE": "None",
  "OPEN_WATER": "OpenWater",
  "BASIC": "Basic",
  "CAVE": "Cave",
  "ADVANCED": "Advanced"
};

const TourismPotential = {
  "UNKNOWN": "Unknown",
  "NONE": "None",
  "LOW": "Low",
  "MEDIUM": "Medium",
  "HIGH": "High"
};

const ExplorationPotential = {
  "UNKNOWN": "Unknown",
  "NONE": "None",
  "LOW": "Low",
  "MEDIUM": "Medium",
  "HIGH": "High",
  "VERY_HIGH": "VeryHigh"
};

const DisabledAccessPotential = {
  "UNKNOWN": "Unknown",
  "NONE": "None",
  "LOW": "Low",
  "MEDIUM": "Medium",
  "HIGH": "High"
};

const TriState = {
  "UNKNOWN": "Unknown",
  "NO": "No",
  "YES": "Yes"
};

const WaterType = {
  "UNKNOWN": "Unknown",
  "FRESH": "Fresh",
  "SALT": "Salt"
};

const Difficulty = {
  "UNKNOWN": "Unknown",
  "EASY": "Easy",
  "INTERMEDIATE": "Intermediate",
  "HARD": "Hard",
  "VERY_HARD": "VeryHard"
};

const WarningGroup = {
  "GENERAL": "General",
  "DIVING": "Diving",
  "CAVING": "Caving"
};

const WarningLevel = {
  "DANGER": "Danger",
  "WARNING": "Warning",
  "INFO": "Info"
};

const Rating = {
  "UNKNOWN": "Unknown",
  "NONE": "None",
  "TERRIBLE": "Terrible",
  "BAD": "Bad",
  "OK": "Ok",
  "GOOD": "Good",
  "EXCELLENT": "Excellent",
  "OUTSTANDING": "Outstanding"
};

const ModificationModel = {
  "PLACE": "Place"
};

const ModificationAction = {
  "CREATE": "Create",
  "UPDATE": "Update",
  "DELETE": "Delete"
};

const DisplayUnits = {
  "METRIC": "Metric",
  "IMPERIAL": "Imperial",
  "BOTH": "Both"
};

const ModerationRequestType = {
  "PLACE": "Place"
};

const ModerationStatus = {
  "SUBMITTED": "Submitted",
  "IN_REVIEW": "InReview",
  "RETURNED": "Returned",
  "APPROVED": "Approved",
  "REJECTED": "Rejected"
};

const { Warning, GroundWater, PlaceReport, PlaceRating, PlaceMediaItem, Place, Journal, UserInfo, UserFilter, PublicFilter, ModerationRequest, PlaceListEntry, PlaceList, S3Object, LatLon, Reference, SpelioData, DiveData, Address, Amenities, WreckData, PlaceData, Media, Modification, KeyValuePair, UserSocials } = initSchema(schema);

export {
  Warning,
  GroundWater,
  PlaceReport,
  PlaceRating,
  PlaceMediaItem,
  Place,
  Journal,
  UserInfo,
  UserFilter,
  PublicFilter,
  ModerationRequest,
  PlaceListEntry,
  PlaceList,
  Visibility,
  MediaContentType,
  ReportVisibility,
  ReportSwell,
  ReportWind,
  LocationType,
  EntryType,
  CaveRating,
  TourismPotential,
  ExplorationPotential,
  DisabledAccessPotential,
  TriState,
  WaterType,
  Difficulty,
  WarningGroup,
  WarningLevel,
  Rating,
  ModificationModel,
  ModificationAction,
  DisplayUnits,
  ModerationRequestType,
  ModerationStatus,
  S3Object,
  LatLon,
  Reference,
  SpelioData,
  DiveData,
  Address,
  Amenities,
  WreckData,
  PlaceData,
  Media,
  Modification,
  KeyValuePair,
  UserSocials
};